// Title and meta description for a static route, from the same list the
// prerender writes into the served HTML (scripts/routes.mjs). Both heads stay in
// the document, so a page that hard-codes its own copy ends up with two
// different descriptions; reading them from here keeps them identical.
import { STATIC_ROUTES } from "../../scripts/routes.mjs";

export interface RouteHead {
  title: string;
  description: string;
}

export function routeHead(path: string): RouteHead {
  const route = (STATIC_ROUTES as { path: string; title: string; description: string }[]).find((r) => r.path === path);
  if (!route) throw new Error(`routeHead: ${path} is not in scripts/routes.mjs`);
  return { title: route.title, description: route.description };
}
